import styled from 'styled-components';

const Wrapper = styled.section`
  margin-top: 1rem;
  margin-bottom: 2rem;

  > .btn {
    background: linear-gradient(135deg, var(--clr-olive, #6b7b5c) 0%, #5a6a4c 100%);
    color: white;
    padding: 0.75rem 1.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(107, 123, 92, 0.25);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(107, 123, 92, 0.35);
    }
  }

  .modal {
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .hide {
    display: none;
  }

  .form {
    margin: 1rem 0;
    padding: 1.5rem;
    background: #fafafa;
    border-radius: 0.75rem;
    border: 1px solid rgba(107, 123, 92, 0.1);

    .input {
      width: 100%;
      margin-top: 0.5rem;
      padding: 0.75rem 1rem;
      background: white;
      border-radius: 0.5rem;
      border: 1px solid #e5e7eb;
      letter-spacing: var(--spacing);
      font-size: 0.9rem;
      resize: vertical;
      min-height: 100px;
      transition: all 0.2s;

      &:focus {
        outline: none;
        border-color: var(--clr-olive, #6b7b5c);
        box-shadow: 0 0 0 3px rgba(107, 123, 92, 0.1);
      }
    }

    .input::placeholder {
      text-transform: capitalize;
      color: #9ca3af;
    }

    .btn-container {
      margin-top: 1rem;
      display: flex;
      gap: 0.75rem;

      a {
        width: 100%;
        text-align: center;
        background: linear-gradient(135deg, var(--clr-olive, #6b7b5c) 0%, #5a6a4c 100%);
        color: white;
        padding: 0.75rem 1.5rem;
        font-weight: 600;
        border-radius: 0.5rem;
        text-decoration: none;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(107, 123, 92, 0.35);
        }
      }

      button {
        flex: 1;
        padding: 0.75rem 1.5rem;
        font-weight: 600;
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        border-radius: 0.5rem;
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .btn:not(.btn-outline) {
        background: linear-gradient(135deg, var(--clr-olive, #6b7b5c) 0%, #5a6a4c 100%);
        color: white;
        border: none;
        box-shadow: 0 2px 8px rgba(107, 123, 92, 0.25);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(107, 123, 92, 0.35);
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }
      }
    }

    .btn-outline {
      background: transparent;
      border: 2px solid var(--clr-olive, #6b7b5c);
      color: var(--clr-olive, #6b7b5c);
      box-shadow: none;

      &:hover {
        background: rgba(107, 123, 92, 0.1);
        transform: translateY(-2px);
      }
    }
  }

  @media (min-width: 992px) {
    .form {
      padding: 2rem;
      max-width: 500px;
      margin-left: 0;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

      .input {
        min-height: 120px;
        font-size: 1rem;
      }

      .btn-container {
        a {
          width: fit-content;
          padding: 0.875rem 2rem;
        }

        button {
          flex: 0 0 auto;
          min-width: 120px;
          padding: 0.875rem 2rem;
        }
      }
    }
  }
`;

export default Wrapper;
